// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"596":"01bfe54d","621":"75a12bd7"}[chunkId] + ".chunk.css";
};